
import { Component, Prop } from 'vue-property-decorator';
import VFormBuilder from '../shared/form/VFormBuilder.vue';
import { InputType } from '@/enums/InputType';
import { Tag } from '@/interfaces/models/Tag';
import StackedForm from '../../mixins/StackedForm';
import { mixins } from 'vue-class-component';

@Component({
  components: { VFormBuilder },
})
export default class TableForm extends mixins(StackedForm) {
  @Prop({ type: Boolean }) public lightspeedAuthorized!: boolean;
  @Prop({ type: Array, required: true }) public tags!: Tag[];

  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  get items() {
    return [
      { name: 'number', type: InputType.Text, label: 'table.form.number', rules: 'required' },
      { name: 'sanifairDeviceId', type: InputType.Text, label: 'table.form.sanifairDeviceId' },
      { name: 'simphonyRvcRef', type: InputType.Text, label: 'table.form.simphonyRvcRef' },
      { name: 'description', type: InputType.Language, label: 'table.form.description' },
      {
        name: 'lightspeedWaiterId',
        type: InputType.Text,
        label: 'table.form.lightspeedWaiterId',
        rules: `greater_eq_than:1`,
      },
      { name: 'tags', type: InputType.Select, label: 'table.table.tags', items: this.tagItems, multiple: true },
      { name: 'active', type: InputType.Checkbox, label: 'table.table.active' },
      {
        name: 'pendingCashPaymentEnabled',
        type: InputType.Checkbox,
        label: 'table.form.pendingCashPaymentEnabled',
        default: false,
        disabled: (form: { openOrdersEnabled: boolean }) => form.openOrdersEnabled,
      },
      {
        name: 'openOrdersEnabled',
        type: InputType.Checkbox,
        label: 'table.form.openOrdersEnabled',
        default: false,
        disabled: (form: { pendingCashPaymentEnabled: boolean }) => form.pendingCashPaymentEnabled,
      },
    ];
  }

  get tagItems() {
    return this.tags.map((t: Tag) => {
      return {
        value: t._id,
        text: this.$options.filters!.localized(t.name),
      };
    });
  }

  public setValue(key: string, value: any): void {
    if (this.$refs.form) {
      this.$refs.form.setValue(key, value);
    }
  }

  public getData() {
    return { ...this.$refs.form.form };
  }
}
